// import { tUnderConstruction } from './SL00000Sprint00'
import { se_2_1of4_PAaA, xyz_2_1of4, xyz_2_2of4, xyz_1_3of4 } from './SL44000Sprint02TTR'
import { list20000Sprint01 } from '../ActivityLists/AL20000Sprint01'
import { list20000Sprint02 } from '../ActivityLists/AL20000Sprint02'
import { breakoutStandard } from './SLSprint00'

import { submissionPercentage } from './SLSprint00'
import { orderedListSlide } from './SLSprint00'

import { xyz_n_4of4 } from './SL44000Sprint01TTR'
import { se_2_4of4_PAaA, se_3_1of4_PAaA } from './SL44000Sprint02TTR'

// import { se_2_4of4_PAaA, se_3_1of4_PAaA  } from './SL44000Sprint02TTR'

// Introduction to Computer Science (ICS) sprint 1 values.
const sprint = 2
const activityList = () => { return list20000Sprint02(sprint) }
const activityListPrevious = () => { return list20000Sprint01(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ics_2_1of4 = () => { return xyz_2_1of4(se_2_1of4_PAaA, ics_2_2of4_PAaA, sprintAndActivityLists) }

// Session 2 of 4: Thursday
const ics_2_2of4_PAaA = {
	'prework':[
		'Complete through activity 6 prior to next class', '',
		'Be prepared for Demos and Retrospectives',
		'Focus on reading “Computer Science Illuminated” The Big Picture and review chapter 1 lecture',
		'Be prepared for “Computer Science Illuminated” The Big Picture Breakout' ],
	'announcements':[
		'Recall that next week is asynchronous remote**' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
}
const ics_2_2of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:27, submitted:26 },
			{ name: 'Quiz', due:27, submitted:27 },
			{ name: 'Lab', due:27, submitted:24 },
			{ name: 'Reflection', due:27, submitted:24 }])
	} 
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Missing 3 Lab ${sprint-1} assignments does not feel good`,
			'Some Lab and Reflection assignments not posted', 
			'Lots of nice comments about scrum teammates',
			'Be **sure** to put something in for each question so that I can give you at least a point or two',
			'What,no music suggestions or riddles in reflections?!?!',
			'Some difficulties with the thumbnail images', 
			`If you are not where you want to be in the class after sprint ${sprint-1}, let’s set up a time to talk.` ])
	}
	return xyz_2_2of4(ics_2_2of4_PAaA, ics_2_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective ) }

// Session 3 of 4: Tuesday
const breakoutTheBigPictureName = 'The Big Picture'
const breakoutTheBigPicture = () => { 
	return breakoutStandard( 
		`Breakout: ${breakoutTheBigPictureName}`, 
		`In this breakout session on our ${breakoutTheBigPictureName} reading and lecture your team will discuss:`, [
		'History', 
		'Abstraction', 
		'Data & Information',
		'Programming',
		'The Internet & The Web',
		'Artificial Intelligence' ])
}
const ics_2_3of4_PAaA = {
	'prework':[
		'Complete through activity 12 prior to next class', '',
		'Be prepared to check in with your team next week',
		'Be prepared for asynchronous remote work' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		`All sprint ${sprint} activities and assignments due Sunday!` ],
	'agenda':[
		`[[update]] Sprint ${sprint} Planning Questions & Answers`,
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
}
const ics_2_3of4 = () => { return xyz_1_3of4(ics_2_3of4_PAaA, ics_2_4of4_PAaA, sprintAndActivityLists, breakoutTheBigPicture) }

export const ics_2_4of4_PAaA = {
	'prework':[
		'Make your initial Discussion 1 post',
		'Complete through activity 11 prior to next class', 
		'Focus on reading Engineering Software as a Service Chapter 2 and the associated lecture',
		'Be prepared for Quiz 1' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		`All sprint ${sprint} activities and assignments due Sunday!` ],
	'agenda':[
		'Review Azure Website',
		'Prework for Next Class',
		'Quiz 2' ]
}
const ics_2_4of4 = () => { return xyz_n_4of4(sprint, activityList, se_2_4of4_PAaA, se_3_1of4_PAaA.prework ) }


export const ics_2_slidedeckTTR = [ ics_2_1of4, ics_2_2of4, ics_2_3of4, ics_2_4of4 ]